import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import SafeIcon from '../common/SafeIcon';

export default function RecuperarPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (resetError) throw resetError;
      setSubmitted(true);
    } catch (err) {
      console.error('Password reset request failed:', err);
      setError(err.message || 'No se pudo enviar el enlace de recuperación');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-[#FAF9F6] relative overflow-hidden">
      <Link
        to="/login"
        className="absolute top-8 left-8 flex items-center gap-2 text-stone-400 hover:text-[#1B2A4E] transition-colors font-medium z-20"
      >
        <SafeIcon name="ArrowLeft" className="w-5 h-5" /> Volver al login
      </Link>

      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none sol-watermark" style={{ backgroundSize: '800px' }}></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#74ACDF] rounded-full blur-[100px] opacity-20"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#F6B40E] rounded-full blur-[100px] opacity-10"></div>

      <div className="w-full max-w-md bg-white rounded-[40px] shadow-2xl p-10 border border-stone-100 relative z-10">
        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-[#1B2A4E] rounded-2xl flex items-center justify-center text-[#F6B40E] font-bold shadow-xl transform rotate-3 mx-auto mb-6">
            <SafeIcon name="Mail" className="w-8 h-8" />
          </div>
          <h1 className="text-3xl font-editorial font-bold text-[#1B2A4E]">Recuperar contraseña</h1>
          <p className="label-technical text-stone-400 mt-3">Te enviamos un enlace por email</p>
        </div>

        {submitted ? (
          <div className="text-center space-y-6">
            <p className="text-stone-500 text-base leading-relaxed">
              Si el email existe, vas a recibir un enlace para restablecer tu contraseña.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center justify-center gap-2 w-full bg-stone-100 hover:bg-stone-200 text-stone-600 font-bold py-4 rounded-2xl transition-colors"
            >
              <SafeIcon name="ArrowLeft" className="w-5 h-5" /> Volver al login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block label-technical text-stone-400 mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-5 py-4 rounded-2xl border border-stone-200 focus:ring-2 focus:ring-[#74ACDF]/50 bg-stone-50 focus:bg-white outline-none transition-all text-[#1B2A4E] font-medium"
                placeholder="tu@email.com"
              />
            </div>

            {error && (
              <p className="text-red-600 text-sm font-medium bg-red-50 rounded-xl px-4 py-3">{error}</p>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#1B2A4E] hover:bg-[#253969] text-white font-bold py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-3 mt-8"
            >
              {isLoading ? (
                <SafeIcon name="Loader" className="animate-spin w-6 h-6" />
              ) : (
                'Enviar enlace de recuperación'
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
